import { defineComponent as _defineComponent } from 'vue'
interface Props {
    modelValue: string;
    placeholder?: string;
    theme?: string;
  }
  
export default /*@__PURE__*/_defineComponent({
  __name: 'InputSearch',
  props: {
    modelValue: { default: "" },
    placeholder: { default: "Search…" },
    theme: { default: "main" }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const props = __props;

const __returned__ = { props }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})